<template>
	<div class="time-public2">
		<div class="themName">发表时间:</div>
		<div class="row2" :class="{addH:showPicktimeInfos}">
			<span class="themlis hovertext" :class="[selDays === '1' ?selected: '']" @click="seletedF('1')">24小时</span>
			<span class="themlis hovertext" :class="[selDays === '3' ?selected: '']" @click="seletedF('3')">3天</span>
			<span class="themlis hovertext" :class="[selDays === '5' ?selected: '']" @click="seletedF('5')">5天</span>
			<span class="themlis hovertext" :class="[selDays === '7' ?selected: '']" @click="seletedF('7')">7天</span>
			<span class="themlis hovertext" :class="[selDays === '15' ?selected: '']" @click="seletedF('15')">15天</span>
			<span class="themlis hovertext" :class="[selDays === '-1' ?selected: '']" @click="seletedF('-1')">自定义</span>
			<div v-show="showTimePick" class="timePart">
				<!-- <el-date-picker v-model="update_time" type="datetime" placeholder="选择日期" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss">
			</el-date-picker> -->
				<el-date-picker
				size="mini"
					v-model="value1"
					type="daterange"
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					prefix-icon="iconfont iconrili"
					format="yyyy-MM-dd"
					value-format="yyyy-MM-dd"
					@change="timeChange"
					:picker-options="isDisabled"
				></el-date-picker>
			</div>
			<div class="timesinfo" v-show="showPicktimeInfos">【2020-05-07 00:00:00 ~ 2020-06-26 00:00:00】</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
        return {
            selected: {
                selectedClass: true,
                textColor: true,
                borderColor: true
            },
            isSelected: '1',
            value1: '',
            showTimePick: false,
            showPicktimeInfos: false,
            isDisabled: {
                disabledDate(time) {
                    // return false;
                    // 大于某个日期不能选择
                    let myDate = new Date();
                    let _beforeDay = myDate.setDate(new Date().getDate());
                    // return time.getTime() >= _beforeDay;
                    // 设置日期限制 小于某个日期不能选择
                    //return time.getTime() < new Date('2019/07/25 00:00:00').getTime() - 8.64e7;
                    return time.getTime() < myDate.setDate(new Date().getDate() - 30) || time.getTime() >= _beforeDay;
                }
            }
        }
    },
            methods: {
			seletedF(val) {
				this.isSelected = val
				if (this.isSelected === '-1') {
					this.showTimePick = true
					// if(!this.showPicktimeInfos){
					// 	this.value1 = ''
					// }

				}else{
					this.showTimePick = false
					//this.showPicktimeInfos = false
				}

				this.$emit('changeTime', {
                    'days':val,
				})
			},
			timeChange(val) {
				// this.showTimePick = false
				// this.showPicktimeInfos = true
				this.$emit('changeTime', {
					'val': val,
                    'days':'-1',
				})
			}
		},
        props: {
            selDays: {
                type: String|Number
            }
        }
    };
</script>

<style lang="less">
.time-public2 {
	font-size: 14px;
	// margin-top: 10px;
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	//position: relative;

	.themlis {
		margin: 8px 4px;
		display: inline-block;
		padding: 0px 5px;
		height: 24px;
		line-height: 22px;
		border: 1px solid transparent;
		border-radius: 5px;
		cursor: pointer;

		&.selectedClass {
			//color: #41a0ff;
			border: 1px solid #41a0ff;
			border-radius: 5px;
		}
	}

	.themName {
		color: @huiseColor;
		height: 40px;
		line-height: 40px;
	}
	.el-date-editor--daterange.el-input__inner {
		width: 348px;
	}
    .el-date-editor--datetimerange.el-input__inner{
		width: 348px;
	}
	.timePart {
		display: inline-block;
		// z-index: 99999;
		// position: absolute;
		// background-color: #fff;
		// top: -40px;
		// left: 54px;
	}
	.row2 {
		//position: relative;
		height: 40px;
		&.addH {
			height: 58px;
		}

		.timesinfo {
			font-size: 14px;
			height: 14px;
			position: absolute;
			bottom: 18px;
			left: 10px;
		}
	}
}
</style>
